module.exports = __webpack_public_path__ + "img/ic_add_secondary.834a9473.svg";